
import './Template.css';

const Template = ({ children }) => {
    return (
        <div className="template-page">
            <div className="template-cards">
                {/* Left card - Juice brand */}
                <article
                    className="template-card template-card--left"
                    style={{
                        background: 'linear-gradient(180deg, #5f7551 0%, #3b4b33 100%)',
                    }}
                >
                    <div className="template-card__brand-circle">Hydra</div>
                    <h2 className="template-card__title">Hydra Juice</h2>
                    <p className="template-card__subtitle">
                        Your daily dose of vitamin C
                    </p>
                    <div className="template-card__buttons">
                        <button>Our drinks</button>
                        <button>Find us</button>
                        <button>Wellbeings</button>
                        <button>Our latest Podcast</button>
                    </div>
                    <div className="template-card__social-row">
                        <span>🎵</span>
                        <span>▶</span>
                        <span>✕</span>
                        <span>📷</span>
                    </div>
                </article>

                {/* Middle card - Runner */}
                <article
                    className="template-card template-card--center"
                    style={{
                        background:
                            'linear-gradient(180deg, #0f6ccf 0%, #0452a3 100%)',
                    }}
                >
                    <div className="template-card__avatar" />
                    <h2 className="template-card__title">Dena Presley</h2>
                    <p className="template-card__subtitle">
                        Long distance runner
                    </p>
                    <div className="template-card__buttons template-card__buttons--torn">
                        <button>Running Tracks</button>
                        <button>Trail Routes</button>
                        <button>Diet Routine</button>
                    </div>
                    <div className="template-card__social-row">
                        <span>🎵</span>
                        <span>▶</span>
                        <span>✕</span>
                        <span>📷</span>
                    </div>
                </article>

                {/* Right card - Surfing */}
                <article
                    className="template-card template-card--right"
                    style={{
                        background:
                            'linear-gradient(180deg, #f4a9d7 0%, #4e8fd8 100%)',
                    }}
                >
                    <div className="template-card__avatar" />
                    <h2 className="template-card__title">Leroy Cohen</h2>
                    <p className="template-card__subtitle">
                        Bali based surfer 🏄‍♂️
                    </p>
                    <div className="template-card__buttons">
                        <button>Surf School hours</button>
                        <button>Lesson types</button>
                        <button>Never surfed before?</button>
                        <button>Beginner course</button>
                        <button>Group Lessons</button>
                    </div>
                    <div className="template-card__social-row">
                        <span>🎵</span>
                        <span>▶</span>
                        <span>✕</span>
                        <span>📷</span>
                    </div>

                    {/* Mount the editor (children) inside the right card so the demo still works */}
                    {children && (
                        <div className="template-card__editor-slot">
                            {children}
                        </div>
                    )}
                </article>
            </div>
        </div>
    );
};

export default Template;